export default "__VITE_ASSET__Dr8JETIN__"